export default{borderColor:100};
